import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const useLang = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const lang = location.pathname.split('/')[1];

  const switchLanguage = (lng: string) => {
    if (lng === lang) return;
    const newPath = location.pathname.replace(`/${lang}`, `/${lng}`);
    i18n.changeLanguage(lng);
    navigate(newPath + location.search);
  };

  return { lang, switchLanguage };
};
